// Helper function to get correct image path for both local and production
const getImagePath = (path) => {
  return `${process.env.PUBLIC_URL || ''}${path}`;
};

export const products = [
  // Brand Header - Sony
  { type: 'header', brand: 'Sony', category: 'Lens' },
  // Sony Products - Lenses
  {
    id: 24, 
    name: 'Sony FE 70-200 2.8 GM ', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Sony 70-200 2.8 GM .png'),
    fullDescription: 'Delivers outstanding image quality with creamy bokeh and fast, precise AF performance. Ideal for professionals capturing action, events, and portraits with superior clarity..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 25, 
    name: 'Sony FE 70-200 2.8 GM V2', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY_70_-_200_2.8_GM_ii-removebg-preview.png'),
    fullDescription: 'Delivers outstanding image quality with creamy bokeh and fast, precise AF performance. Ideal for professionals capturing action, events, and portraits with superior clarity..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 26, 
    name: 'Sony FE 16-35 2.8 GM V2', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 16 - 35 2.8 GM ii.png'),
    fullDescription: 'Offers ultra-wide coverage with edge-to-edge sharpness and a bright constant aperture. Perfect for professionals shooting landscapes, interiors, and cinematic visuals..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 27, 
    name: 'Sony FE 24-70 2.8 GM V2', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Sony_24-70_2.8_gm_V__-removebg-preview.png'),
    fullDescription: 'Offers ultra-wide coverage with edge-to-edge sharpness and a bright constant aperture. Perfect for professionals shooting landscapes, interiors, and cinematic visuals..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 28, 
    name: 'Sony FE 85 MM 1.8 GM V2', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 85 MM 1.8 GM .png'),
    fullDescription: 'Delivers stunning portrait performance with fast autofocus and smooth bokeh. Ideal for capturing expressive portraits and low-light shots with professional clarity..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 29, 
    name: 'Sony FE 85 MM 1.8 GM  ', 
    category: 'Lens',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 85 MM 1.8 GM.png'),
    fullDescription: 'Delivers stunning portrait performance with fast autofocus and smooth bokeh. Ideal for capturing expressive portraits and low-light shots with professional clarity..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 30, 
    name: 'Sony FE 85MM 2.8 GM', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 85MM 2.8 GM.png'),
    fullDescription: 'Provides excellent optical quality in a compact design, ideal for portraits and everyday photography. It delivers crisp details and smooth bokeh for natural-looking shots..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 31, 
    name: 'Sony FE 35 F1.4 GM', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 35 1.4 GM.png'),
    fullDescription: 'Delivers outstanding low-light performance and creamy background blur. Perfect for street, portrait, and cinematic photography with professional clarity and depth..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 32, 
    name: 'Sony FE 50 F1.4 GM', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 50 1.4 GM.png'),
    fullDescription: 'Offers exceptional image quality with a bright aperture for low-light shooting and shallow depth of field. Ideal for portraits, events, and cinematic visuals..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 33, 
    name: 'Sony FE 50 F1.2 GM', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1300,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 50 1.2 GM.png'),
    fullDescription: 'Delivers outstanding clarity, smooth bokeh, and precise autofocus even in low light. Perfect for professionals seeking top-tier performance in portraits and creative photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 34, 
    name: 'Sony FE 14 F1.8 GM', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 14  1.8 GM .png'),
    fullDescription: 'Combines a bright aperture with edge-to-edge clarity, perfect for astrophotography, landscapes, and architectural shots. Its compact design delivers stunning detail and minimal distortion..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 35, 
    name: 'Sony FE 90 MM F2.8 MICRO', 
    category: 'Lens',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 90 MM 2.8 MICRO.png'),
    fullDescription: 'Delivers exceptional sharpness and lifelike detail with true 1:1 magnification. Ideal for macro, nature, and portrait work with beautiful background separation..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 36, 
    name: 'Sony FE 50 F1.8', 
    category: 'Lens',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 50 1.8 MM.png'),
    fullDescription: 'Delivers excellent image quality and bright performance in a compact design. Perfect for portraits, everyday shots, and low-light photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 37, 
    name: 'Sony FE 85 MM F1.8', 
    category: 'Lens',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 85 MM 1.8 GM .png'),
    fullDescription: 'Delivers superb image quality, fast autofocus, and creamy bokeh. Ideal for portraits, weddings, and low-light photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 38, 
    name: 'Sony FE35 F1.8', 
    category: 'Lens',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 35 1.8.png'),
    fullDescription: 'Delivers excellent image quality and fast autofocus, making it perfect for street, travel, and everyday photography with beautiful low-light performance..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 39, 
    name: 'Sony 24 - 105 F4', 
    category: 'Lens',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 24 - 105 F4 .png'),
    fullDescription: 'Delivers superb clarity, fast autofocus, and reliable performance from wide-angle to telephoto. Ideal for travel, portraits, and everyday professional use..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 40, 
    name: 'Sony FE 12-24MM F 2.8 GM', 
    category: 'Lens',
    originalPrice: 1000,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 12-24MM F 2.8 GM.png'),
    fullDescription: 'Offers stunning edge-to-edge clarity with a fast constant aperture, perfect for landscapes, architecture, and astrophotography with professional precision..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 41, 
    name: 'Sony FE 16 - 35 2.8 II', 
    category: 'Lens',
    originalPrice: 1500,
    price: 1200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 16 - 35 2.8 GM ii.png'),
    fullDescription: 'Delivers brilliant edge-to-edge clarity and smooth bokeh, making it ideal for landscapes, architecture, and creative videography in any lighting condition..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 42, 
    name: 'Sony 200-600MM F2 GM', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 50-150MM  F2 .png'),
    fullDescription: 'Delivers exceptional image quality, fast autofocus, and creamy bokeh, making it perfect for portraits, sports, and event photography with professional precision..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 43, 
    name: 'Sony 24MM F 1.4 GM', 
    category: 'Lens',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SONY 24MM F  1.4 GM.png'),
    fullDescription: 'Offers outstanding clarity, fast autofocus, and excellent low-light performance — perfect for landscapes, astrophotography, and creative storytelling..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 44, 
    name: 'Sigma FE 35 F1.4', 
    category: 'Lens',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/SIGMA 35 1.4 PNG.png'),
    fullDescription: 'Combines outstanding optical performance with a bright aperture, making it ideal for portraits, street, and low-light photography with professional-grade results..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
    // Brand Header - Canon
    { type: 'header', brand: 'Canon', category: 'Lens' },


  {
    id: 45, 
    name: 'Canon 70-200 2.8 II', 
    category: 'Lens',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Canon-70-200 2.8.png'),
    fullDescription: 'Delivers outstanding image quality, creamy bokeh, and reliable performance — perfect for sports, weddings, and portrait photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 46, 
    name: 'Canon 16-35 2.8 II', 
    category: 'Lens',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 16 - 35 2.8.png'),
    fullDescription: 'Delivers exceptional edge-to-edge clarity and vibrant color, making it ideal for landscapes, architecture, and creative wide-angle photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 47, 
    name: 'Canon 24-70 2.8 II', 
    category: 'Lens',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 24 - 70 2.8.png'),
    fullDescription: 'Delivers outstanding sharpness, fast autofocus, and beautiful bokeh — perfect for portraits, events, and everyday professional photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 48, 
    name: 'Canon 85MM 1.2', 
    category: 'Lens',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 85MM 1.2.png'),
    fullDescription: 'Delivers stunning image quality with a bright aperture, creating dreamy background separation — perfect for portraits, fashion, and low-light photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 49, 
    name: 'Canon 24-105 F4', 
    category: 'Lens',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 24-105 F4.png'),
    fullDescription: 'Ideal for portraits, travel, and video, offering sharp optics and durable L-series build quality..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 50, 
    name: 'Canon 50MM 1.4', 
    category: 'Lens',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 5OMM 1.4.png'),
    fullDescription: 'Delivers excellent low-light performance and beautiful bokeh. Compact and versatile, it’s ideal for portraits, street, and everyday photography with a natural field of view..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 51, 
    name: 'Canon 50MM 1.8', 
    category: 'Lens',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 5OMM 1.8.png'),
    fullDescription: 'Offers great image quality and bright aperture performance for portraits and low-light shots. Compact and reliable, it’s a perfect everyday lens for beginners and enthusiasts alike..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 52, 
    name: 'Canon 35MM 1.4', 
    category: 'Lens',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON 35MM 1.4.png'),
    fullDescription: 'Delivers outstanding low-light performance, smooth bokeh, and precise focus. Ideal for street, landscape, and portrait photography, it’s a favorite among professionals for its versatility and image quality..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  // Brand Header - Zeiss CP2
  { type: 'header', brand: 'CP2 lens kit', category: 'Lens' },
  {
    id: 57, 
    name: 'CP2 15mm,21mm,35mm,50mm,85mm', 
    category: 'Lens',
    originalPrice: 2200,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CP2.png'),
    fullDescription: 'Delivers full-frame coverage, smooth manual focus, and exceptional image quality. Ideal for portraits and close-up cinematic shots, it provides the signature Zeiss contrast and cinematic depth..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
    // Brand Header - Canon
    { type: 'header', brand: 'Nikon', category: 'Lens' },

  {
    id: 58, 
    name: 'Nikon 18-55', 
    category: 'Lens',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Nikon_18-55mm.png'),
    fullDescription: 'Offers versatile focal lengths, smooth autofocus, and lightweight design. Perfect for beginners, it’s great for capturing landscapes, portraits, and daily moments with ease..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 59, 
    name: 'Nikon 18-135', 
    category: 'Lens',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Nikon_18-135mm.png'),
    fullDescription: 'Delivers excellent performance from wide-angle to telephoto, with fast and quiet autofocus. Ideal for travel, portraits, and landscapes, it’s a reliable lens for all-around photography..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
  {
    id: 60, 
    name: 'Nikon 70-300', 
    category: 'Lens',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/Nikon_70-300.png'),
    fullDescription: 'Delivers excellent image quality, fast autofocus, and effective image stabilization. Ideal for wildlife, sports, and portrait photography, it offers great reach in a compact, lightweight design..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },
    // Brand Header - Canon
    { type: 'header', brand: 'red camera', category: 'Camera' },

  { 
    id: 61, 
    name: 'Red Dragon 6k', 
    category: 'Camera',
    originalPrice: 5000,
    price: 4000,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/Red Gemini 6K.png'),
    fullDescription: 'Delivers stunning 6K resolution, wide dynamic range, and cinematic color reproduction. Ideal for filmmakers, it excels in both bright and low-light conditions with remarkable detail and flexibility..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },
    // Brand Header - Canon
    { type: 'header', brand: 'sony', category: 'Camera' },

  { 
    id: 62, 
    name: 'Sony FX6', 
    category: 'Camera',
    originalPrice: 6000,
    price: 5000,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/SONY FX6.png'),
    fullDescription: 'Delivers stunning 4K recording, fast autofocus, and high dynamic range. Compact and powerful, it’s perfect for filmmakers and content creators seeking professional results in a lightweight body..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  }, 
  { 
    id: 63, 
    name: 'Sony FX3', 
    category: 'Camera',
    originalPrice: 4000,
    price: 3000,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/FX3.png'),
    fullDescription: 'Delivers cinematic 4K video, excellent low-light performance, and advanced autofocus. Combining the power of Sony’s Cinema Line with a portable design, it’s perfect for handheld and on-the-go shooting..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },  
  { 
    id: 64, 
    name: 'Sony A7 S III', 
    category: 'Camera',
    originalPrice: 3500,
    price: 2500,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/sony 2.png'),
    fullDescription: 'Offers 4K 120p recording, superb dynamic range, and fast autofocus. Ideal for filmmakers and content creators, it excels in cinematic production and high-sensitivity shooting..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },  
  { 
    id: 65, 
    name: 'Sony A7 R IV', 
    category: 'Camera',
    originalPrice: 3000,
    price: 2500,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/SONY A7 R IV .png'),
    fullDescription: 'Features a 61MP sensor, fast autofocus, and excellent color accuracy. Perfect for landscape, studio, and commercial photography, it offers professional-grade sharpness and performance..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },
  { 
    id: 66, 
    name: 'Sony A7 IV', 
    category: 'Camera',
    originalPrice: 3000,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/SONY A7 iii .png'),
    fullDescription: 'Features a 24.2MP sensor, 4K video recording, and fast autofocus. Ideal for both photographers and videographers, it delivers outstanding results in a compact, versatile body..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },  
 
  { 
    id: 67, 
    name: 'Sony Z 280', 
    category: 'Camera',
    originalPrice: 4000,
    price: 3000,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.9,
    reviews: 245,
    image: getImagePath('/assets/Camera/SONY Z 280.png'),
    fullDescription: 'Delivers superb 4K HDR recording, advanced autofocus, and powerful connectivity options. Ideal for broadcast, documentary, and event production, it offers exceptional performance in a compact form factor..',
    features: ['12.1MP Full-Frame Sensor', '4K 120fps Video Recording', 'Advanced Real-time Eye AF', '5-Axis In-Body Stabilization', 'Dual Card Slots (CFexpress/SD)', '15+ Stop Dynamic Range'],
    specifications: { 'Sensor': '12.1MP Full-Frame', 'Video': '4K 120fps', 'ISO': '80-102400', 'Battery Life': '600 shots' }
  },   
  { type: 'header', brand: 'canon', category: 'Camera' },
 
  {
    id: 69, 
    name: 'Canon 5D Mark IV Body', 
    category: 'Camera',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 312,
    image: getImagePath('/assets/Lens/CANNON_5D_MARK_IV_BODY-removebg-preview.png'),
    fullDescription: 'Combines outstanding optical performance with a bright aperture, making it ideal for portraits, street, and low-light photography with professional-grade results..',
    features: ['24-70mm Versatile Range', 'Constant f/2.8 Aperture', 'Latest G Master Optics', 'XD Linear Motors', 'Weather-Sealed Construction', 'Lightweight Design'],
    specifications: { 'Focal Length': '24-70mm', 'Aperture': 'f/2.8', 'Weight': '695g', 'Mount': 'Sony E' }
  },                                                         
    { 
    id: 69, 
    name: 'Dji Mic Wireless Microphone', 
    category: 'Audio',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/dji-mic-wireless-microphone-removebg.png'),
    fullDescription: 'Offers high-quality sound, long transmission range, and dual-channel recording. Perfect for vlogging, interviews, filmmaking, and professional content creation. Features 14-hour battery life, 250-meter transmission range, built-in storage, and automatic noise reduction for professional-grade audio capture.',
    features: ['Wireless Transmission', 'Dual-Channel Recording', 'Built-in Storage', 'Long Battery Life', 'Auto Noise Reduction', 'Compact Design'],
    specifications: { 'Type': 'Wireless Microphone System', 'Range': 'Up to 250m', 'Battery': '14 hours', 'Channels': 'Dual', 'Storage': '8GB Built-in' }
  },
  { 
    id: 70, 
    name: 'Road Boom Pole', 
    category: 'Audio',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/Road_Boom_Pole-removebg-preview.png'),
    fullDescription: 'Offers durable construction, smooth extension, and secure locking mechanisms. Perfect for film, TV, and field recording to capture clear, focused audio. Features telescopic extension, comfortable grip, cable management, and professional-grade stability for superior sound capture during production.',
    features: ['Telescopic Extension', 'Secure Locking Mechanism', 'Cable Management', 'Lightweight Design', 'Professional Stability', 'Comfortable Grip'],
    specifications: { 'Type': 'Boom Pole', 'Length': 'Adjustable', 'Material': 'Carbon Fiber/Aluminum', 'Max Extension': 'Variable', 'Weight': 'Lightweight' }
  }, 
  { 
    id: 71, 
    name: 'Sennheiser ew100 g3 Wireless Microphone Set', 
    category: 'Audio',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/sennheiser-ew100-g3-wireless-microphone-set-removebg-preview.png'),
    fullDescription: 'Offers excellent sound quality, strong signal stability, and easy setup. Ideal for live performances, interviews, and broadcast production. Features multiple frequency channels, automatic frequency scanning, pilot tone squelch, and robust construction for dependable operation in professional environments.',
    features: ['Multi-Channel System', 'Auto Frequency Scanning', 'Pilot Tone Squelch', 'High Sound Quality', 'Easy Setup', 'Professional Grade'],
    specifications: { 'Type': 'Wireless Microphone System', 'Frequency Range': 'UHF', 'Channels': 'Multiple', 'Range': 'Up to 100m', 'Connectivity': 'XLR Output' }
  }, 
  { 
    id: 72, 
    name: 'Sennheiser hd202 Headphone', 
    category: 'Audio',
    originalPrice: 600,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/sennheiser-hd202-headphone-removebg-preview.png'),
    fullDescription: 'Offers dynamic audio performance, comfortable fit, and effective noise isolation. Ideal for DJing, studio monitoring, and everyday music listening. Features closed-back design, excellent sound reproduction, durable construction, and long-lasting comfort for extended use in professional audio environments.',
    features: ['Closed-Back Design', 'Powerful Bass Response', 'Noise Isolation', 'Comfortable Fit', 'Durable Construction', 'Professional Sound'],
    specifications: { 'Type': 'Over-Ear Headphones', 'Frequency': '18-18000Hz', 'Impedance': '32 Ohms', 'Sensitivity': '110 dB', 'Weight': '220g' }
  }, 
  { 
    id: 73, 
    name: 'Shure Podcast Mic sm7b', 
    category: 'Audio',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/shure-podcast-mic-sm7b-removebg-preview.png'),
    fullDescription: 'Offers exceptional vocal clarity, noise rejection, and wide frequency response. Ideal for podcasting, broadcasting, voiceovers, and studio recording. Features cardioid polar pattern, built-in pop filter, smooth frequency response, and low self-noise for professional-grade audio capture in any recording environment.',
    features: ['Cardioid Polar Pattern', 'Built-in Pop Filter', 'Wide Frequency Response', 'Low Self-Noise', 'Professional Standard', 'XLR Output'],
    specifications: { 'Type': 'Dynamic Microphone', 'Frequency': '50-20000Hz', 'Impedance': '150 Ohms', 'Weight': '765g', 'Polar Pattern': 'Cardioid' }
  }, 
  { 
    id: 74, 
    name: 'H6 ZOOM RECORDER', 
    category: 'Audio',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/H6 ZOOM RECORDER .png'),
    fullDescription: 'Features interchangeable microphone capsules, high-quality preamps, and flexible input options. Perfect for podcasts, film production, music recording, and field interviews. Offers six-track simultaneous recording, studio-quality sound capture, and intuitive controls for professional audio professionals.',
    features: ['6-Track Simultaneous Recording', 'Interchangeable Mic Capsules', 'High-Quality Preamps', 'Dual XLR Inputs', 'USB Audio Interface', 'Compact Portable Design'],
    specifications: { 'Type': 'Portable Audio Recorder', 'Tracks': '6 Simultaneous', 'Inputs': '2 XLR/TRS', 'Battery': 'Rechargeable Li-ion', 'Weight': '270g' }
  },
  { 
    id: 75, 
    name: 'DGI I RS PRO 4', 
    category: 'Gimbal',
    originalPrice: 2000,
    price: 1700,
    ShortDescription: 'For More details, Contact Us',
    discount: 16,
    rating: 4.7,
    reviews: 167,
    image: getImagePath('/assets/Gimbal/dji rs 4.png'),
    fullDescription: 'Offers advanced stabilization, strong payload capacity, and intuitive controls for filmmakers.Ideal for handheld filming, cinematic shots, and professional video production..',
    features: ['6.5kg Payload Capacity', 'ViaTouch Control System', 'Smart Wheel Controller', 'Modular Design', 'Extended Battery', 'Professional Modes'],
    specifications: { 'Payload': '6.5kg', 'Battery': '18 hours', 'Weight': '2.2kg', 'Compatibility': 'Cinema Cameras' }
  },
  { 
    id: 76, 
    name: 'DGI I RS PRO 3', 
    category: 'Gimbal',
    originalPrice: 1800,
    price: 1300,
    ShortDescription: 'For More details, Contact Us',
    discount: 16,
    rating: 4.7,
    reviews: 167,
    image: getImagePath('/assets/Gimbal/dji rs 3.png'),
    fullDescription: 'Offers advanced stabilization, high payload support, and smart controls for creative filmmaking.Perfect for handheld shooting, cinematic sequences, and professional video production..',
    features: ['6.5kg Payload Capacity', 'ViaTouch Control System', 'Smart Wheel Controller', 'Modular Design', 'Extended Battery', 'Professional Modes'],
    specifications: { 'Payload': '6.5kg', 'Battery': '18 hours', 'Weight': '2.2kg', 'Compatibility': 'Cinema Cameras' }
  },
  { 
    id: 77, 
    name: 'DGI I RS PRO 2', 
    category: 'Gimbal',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 16,
    rating: 4.7,
    reviews: 167,
    image: getImagePath('/assets/Gimbal/DGI RS 2.png'),
    fullDescription: 'Offers advanced stabilization, high payload capacity, and intuitive controls for filmmakers.Ideal for handheld shooting, cinematic shots, and professional video production..',
    features: ['6.5kg Payload Capacity', 'ViaTouch Control System', 'Smart Wheel Controller', 'Modular Design', 'Extended Battery', 'Professional Modes'],
    specifications: { 'Payload': '6.5kg', 'Battery': '18 hours', 'Weight': '2.2kg', 'Compatibility': 'Cinema Cameras' }
  },
  { 
    id: 78, 
    name: 'Cren(3)', 
    category: 'Gimbal',
    originalPrice: 1400,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 16,
    rating: 4.7,
    reviews: 167,
    image: getImagePath('/assets/Gimbal/cren(3).png'),
    fullDescription: 'The Zhiyun Crane 3S is built to handle the demands of cinema production. With a massive 6.5kg payload and advanced stabilization algorithms, it provides silky-smooth footage even with heavy camera rigs.',
    features: ['6.5kg Payload Capacity', 'ViaTouch Control System', 'Smart Wheel Controller', 'Modular Design', 'Extended Battery', 'Professional Modes'],
    specifications: { 'Payload': '6.5kg', 'Battery': '18 hours', 'Weight': '2.2kg', 'Compatibility': 'Cinema Cameras' }
  }, 
  { 
    id: 79, 
    name: 'Aputure INFINIBAR PB12 RGB', 
    category: 'Lights',
    originalPrice: 6500,
    price: 5500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure INFINIBAR PB12 RGB LED Light Panel 8 .png'),
    fullDescription: 'Provides dynamic lighting effects, precise color accuracy, and seamless connectivity. Ideal for film, photography, and studio setups, it delivers creative flexibility with powerful RGB lighting options.',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 80, 
    name: 'Aputure XT26', 
    category: 'Lights',
    originalPrice: 5000,
    price: 3500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure XT26.png'),
    fullDescription: 'Delivers powerful illumination, precise color accuracy, and versatile control options. Ideal for cinematic production, it combines robust build quality with exceptional lighting performance..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 81, 
    name: 'Aputure Electro storm CS15', 
    category: 'Lights',
    originalPrice: 4000,
    price: 3000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure Electro storm CS15.png'),
    fullDescription: 'Offers exceptional brightness, full-color control, and advanced connectivity. Ideal for cinematic lighting, it delivers powerful performance, accurate color, and seamless integration into any production setup..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 82, 
    name: 'Aputure Nova P600c ', 
    category: 'Lights',
    originalPrice: 3000,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure Nova P600c RGBWW LED .png'),
    fullDescription: 'Offers full-color control, high brightness, and versatile lighting effects. Ideal for film, television, and studio production, it provides professional-grade lighting with precision and flexibility..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 83, 
    name: 'Aputure Nova P300c ', 
    category: 'Lights',
    originalPrice: 2500,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure Nova P300C RGBWW Light.png'),
    fullDescription: 'Delivers soft, high-quality light with full RGB color and CCT adjustment. Ideal for film, TV, and studio production, it offers powerful output, customizable effects, and wireless control options..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 84, 
    name: 'Aputure LS 1200d Pro', 
    category: 'Lights',
    originalPrice: 3500,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 1200d Pro LED Light.png'),
    fullDescription: 'Delivers exceptional brightness, durable build quality, and precise lighting control. Ideal for cinematic shoots, it offers high output, weather resistance, and advanced connectivity for reliable on-set performance..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 85, 
    name: 'Aputure LS 600d Pro', 
    category: 'Lights',
    originalPrice: 2000,
    price: 1250,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 600d Pro LED Light.png'),
    fullDescription: 'Delivers powerful brightness, excellent color accuracy, and weather-resistant design. Ideal for cinematic and studio setups, it offers versatile control options and reliable performance in any environment..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 86, 
    name: 'Aputure LS 600c Pro', 
    category: 'Lights',
    originalPrice: 2500,
    price: 1800,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 600C Pro RGB Light.png'),
    fullDescription: 'Delivers powerful output, precise color accuracy, and versatile lighting effects. Ideal for film and studio production, it combines robust performance with advanced wireless and wired control options..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { 
    id: 87, 
    name: 'Aputure LS 600x Pro', 
    category: 'Lights',
    originalPrice: 2500,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 600x Pro.png'),
    fullDescription: 'Delivers excellent brightness, adjustable CCT range, and advanced control options. Ideal for film, TV, and studio production, it combines flexibility, durability, and professional-grade lighting performance..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 88, 
    name: 'Aputure Light Storm 1200dPro', 
    category: 'Lights',
    originalPrice: 2500,
    price: 1250,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure_Light-Storm-1200d-Pro.png'),
    fullDescription: 'Offers intense brightness, superior color accuracy, and weather-resistant design. Ideal for film and studio production, it provides reliable performance and precise control for demanding lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },    
  { 
    id: 89, 
    name: 'Amaron 200 S', 
    category: 'Lights',
    originalPrice: 1500,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/AMARAN 200 S.png'),
    fullDescription: 'Delivers reliable performance with quick charging and deep discharge recovery. Ideal for home and office use, it ensures consistent power supply and durability even under heavy usage..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },      
  { 
    id: 90, 
    name: 'Amaron 300c', 
    category: 'Lights',
    originalPrice: 2000,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Amaron 300c .png'),
    fullDescription: 'Offers excellent performance with fast charging and extended battery life. Ideal for home, office, and industrial use, it ensures consistent power delivery and superior energy efficiency..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 91, 
    name: 'Aputure LS 300X ', 
    category: 'Lights',
    originalPrice: 2000,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 300X Bi-color light.png'),
    fullDescription: 'Delivers excellent brightness, adjustable CCT range, and accurate color rendering. Ideal for film, photography, and studio production, it combines versatility, reliability, and professional-grade lighting performance..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { 
    id: 92, 
    name: 'Aputure LS 300D ', 
    category: 'Lights',
    originalPrice: 2000,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 300D II light.png'),
    fullDescription: 'Delivers strong output, excellent color accuracy, and durable build quality. Ideal for film, photography, and studio work, it provides professional lighting performance with flexible control options..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 93, 
    name: 'Aputure LS 120D', 
    category: 'Lights',
    originalPrice: 1500,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 120D II light.png'),
    fullDescription: 'Delivers powerful illumination with efficient cooling and quiet operation. Ideal for film, photography, and studio production, it’s lightweight, reliable, and perfect for professional lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 94, 
    name: 'Aputure LS 60D', 
    category: 'Lights',
    originalPrice: 1500,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure LS 60D Light.png'),
    fullDescription: 'Delivers high output with adjustable beam angles and excellent color accuracy. Ideal for film, photography, and studio use, it’s lightweight, versatile, and perfect for on-location lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 95, 
    name: 'Aputure Amaron F22C', 
    category: 'Lights',
    originalPrice: 2000,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure Amaron F22C RGBWW Light.png'),
    fullDescription: 'Delivers exceptional brightness, accurate color reproduction, and versatile mounting options. Ideal for film, studio, and on-location shoots, it provides creative lighting flexibility in a lightweight, foldable design..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 96, 
    name: 'Aputure MC 4', 
    category: 'Lights',
    originalPrice: 1500,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure MC 4 light travel kit.png'),
    fullDescription: 'Provides full HSI color control, built-in effects, and wireless connectivity. Ideal for filmmakers and photographers, it’s perfect for creative lighting setups with portability and flexibility..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 97, 
    name: 'Aputure Amaran P60C', 
    category: 'Lights',
    originalPrice: 1000,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure Amaran P60C RGBWW.png'),
    fullDescription: '.',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 98, 
    name: 'Aputure B7C', 
    category: 'Lights',
    originalPrice: 500,
    price: 250,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Aputure B7C RGBWW Smart bulb.png'),
    fullDescription: 'Offers accurate color reproduction, built-in battery power, and wireless app control. Ideal for film, photography, and practical lighting setups, it combines creativity and convenience in a compact bulb design..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 99, 
    name: 'Godox FL150R', 
    category: 'Lights',
    originalPrice: 1200,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Godox FL150R Flexible .png'),
    fullDescription: 'Delivers high brightness, excellent color accuracy, and flexible mounting options. Ideal for film, portrait, and studio photography, it provides versatile lighting control in a lightweight, foldable design..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 100, 
    name: 'Nanlite Pavotube 4ft', 
    category: 'Lights',
    originalPrice: 1200,
    price: 800,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Nanlite Pavotube RGB 4ft (80cm) .png'),
    fullDescription: 'Delivers excellent brightness, adjustable color temperature, and built-in effects. Ideal for film, photography, and creative lighting setups, it’s portable, versatile, and perfect for on-location shoots..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 101, 
    name: 'Amaron PT2C 2 Feet', 
    category: 'Lights',
    originalPrice: 1200,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Amaron PT2C 2 Feet RGB LED Pixel Tube .png'),
    fullDescription: 'Offers high brightness, adjustable color temperature, and precise RGB control. Its portable design and versatile mounting options make it ideal for interviews, video shoots, and creative setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 102, 
    name: 'Godox Lc500R', 
    category: 'Lights',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Godox Lc500R LED lightstick.png'),
    fullDescription: 'Offers full RGB color tuning, adjustable brightness, and built-in effects for cinematic lighting. Its lightweight, portable wand design makes it perfect for handheld or mounted use in photo and video production..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 103, 
    name: 'Arri Sky Panel S60', 
    category: 'Lights',
    originalPrice: 3000,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/Arri Sky Panel S60 .png'),
    fullDescription: 'Offers adjustable color temperature, full RGBW control, and exceptional light quality. Its widely used in film and broadcast production for its versatility and uniform soft illumination..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 104, 
    name: '1000 BulpsPanel', 
    category: 'Lights',
    originalPrice: 1000,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights/1 with battery .png'),
    fullDescription: 'Delivers bright, even lighting with adjustable color temperature and dimming control, making it ideal for photography, film, and broadcast environments..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { type: 'header', brand: 'Softboxes', category: 'Lights' },

  { 
    id: 105, 
    name: 'Aputure Light dome II', 
    category: 'Lights',
    originalPrice: 1400,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Light dome II softbox.png'),
    fullDescription: 'Features high-quality diffusion fabric, a quick-setup design, and a deep parabolic shape that produces beautiful, cinematic lighting for interviews and studio shoots..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 106, 
    name: 'Aputure Light dome mini II', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Light dome mini II softbox.png'),
    fullDescription: 'Offers a 60cm diameter design, perfect for small studios or tight spaces. It delivers soft yet controlled light output and is compatible with Bowens mount fixtures for quick setup and portability..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 107, 
    name: 'Aputure Light dome 150', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Light Dome 150 Softbox.png'),
    fullDescription: 'Features a 150cm diameter for broad, diffused illumination, ideal for interviews, portraits, and film sets. It provides natural, wraparound light with easy setup and compatibility with Bowens mount lights..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 108, 
    name: 'Aputure Lantern 90', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Lantern 90 Softbox.png'),
    fullDescription: 'Provides 360° soft and even illumination, ideal for lighting up entire rooms or scenes. Its quick-setup design and Bowens mount make it perfect for film, studio, and event lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 109, 
    name: 'Aputure Lantern', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Lantern.png'),
    fullDescription: 'Provides 360° soft and even illumination, ideal for lighting up entire rooms or scenes. Its quick-setup design and Bowens mount make it perfect for film, studio, and event lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 110, 
    name: 'Aputure Spacelight', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Aputure Spacelight.png'),
    fullDescription: 'The Aputure Space Light attaches to compatible Aputure lights, spreading light evenly in all directions. It’s ideal for film, studio, and set environments where a smooth, ambient glow is required..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 111, 
    name: 'Godox Octa 120', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox Octa 120cm Softbox.png'),
    fullDescription: 'Produces smooth, natural light with pleasing round catchlights. It’s ideal for portraits, fashion, and product photography, offering controlled diffusion and easy setup..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 112, 
    name: 'Octa 120cm Parabolic', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Octa 120cm Parabolic.png'),
    fullDescription: 'Provides a beautiful wraparound light with strong directionality and contrast control. Ideal for cinematic and portrait lighting, it enhances depth and natural highlights..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 113, 
    name: ' Godox Octa 80cm ', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox Octa 80cm Softbox.png'),
    fullDescription: 'Delivers smooth and natural illumination, perfect for portraits, interviews, and small studio setups, offering easy portability with professional light diffusion..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { 
    id: 114, 
    name: ' Godox 35x160cm  ', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox 35x160cm Softbox.png'),
    fullDescription: ' Provides a narrow and even light spread, ideal for edge lighting, fashion shoots, and product photography, enhancing subject separation and dimensionality..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 115, 
    name: ' Godox Parabolic p90h', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox-parabolic-softbox-p90h.png'),
    fullDescription: 'Features a deep parabolic design for precise light control and beautiful contrast, making it ideal for portrait, film, and commercial shoots with professional-grade diffusion..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { 
    id: 116, 
    name: ' Godox SB GUE 120', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox SB GUE 120.png'),
    fullDescription: ' Offers excellent diffusion and natural catchlights, featuring a quick umbrella-style setup. It’s perfect for portraits, fashion, and studio photography requiring smooth, balanced illumination..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { 
    id: 117, 
    name: ' Godox 165 sliver', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox-165-sliver-umbrella.png'),
    fullDescription: 'Delivers powerful, specular light with crisp highlights, ideal for fashion, product, and dramatic portrait photography, offering excellent light output and wide coverage..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 118, 
    name: ' Godox 165 white', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox-165-white-umbrella.png'),
    fullDescription: 'Offers gentle, even illumination with natural skin tones, ideal for portraits, interviews, and studio setups requiring smooth, low-contrast light..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 119, 
    name: 'Elinchorm Rotalux Octa 135', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchorm Rotalux Octa 135.png'),
    fullDescription: 'Provides beautifully diffused illumination with natural catchlights, ideal for portrait, beauty, and fashion photography, ensuring smooth transitions and flattering skin tones..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  { 
    id: 120, 
    name: 'Elinchorm Rotalux Deep Octa 100', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchorm Rotalux Deep Octa 100.png'),
    fullDescription: 'Delivers soft yet directional lighting with rich contrast and natural falloff, making it perfect for portrait, beauty, and commercial photography setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications:{ 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { 
    id: 121, 
    name: 'Godox 130 White', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox-130-white-umbrella.png'),
    fullDescription: 'Offers broad, even illumination with gentle shadows, ideal for portraits, interviews, and studio lighting setups requiring a smooth, flattering glow..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 122, 
    name: 'Godox 105 White', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox-105-white-umbrella.png'),
    fullDescription: 'Delivers smooth diffusion with minimal shadows, ideal for portrait and product photography, offering a lightweight and portable solution for soft illumination..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  {
    id: 123, 
    name: 'Harison octa 60', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Harison-octa-60-softbox.png'),
    fullDescription: ' Produces even, diffused light with pleasing catchlights, making it perfect for close-up portraits, interviews, and compact studio setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 124, 
    name: 'Elinchorm Rotalux 175', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchrom-rotalux-175cm-octabox.png'),
    fullDescription: 'Delivers smooth, diffused illumination ideal for portrait, beauty, and product photography, offering portability and natural light quality in compact shooting spaces..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 125, 
    name: 'Elinchorm octa 175', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchrom octa 175cm.png'),
    fullDescription: 'Delivers expansive, even illumination with natural catchlights, ideal for fashion, portrait, and commercial photography requiring smooth, flattering light and subtle shadow transitions..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 126, 
    name: 'Elinchorm Portalite 66x66', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchorm Portalite 66x66cm.png'),
    fullDescription: 'Offers balanced, diffused illumination with gentle contrast, ideal for portrait and product photography, making it a versatile and portable light modifier for studio use..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  {
    id: 127, 
    name: 'Elinchorm Rotalux Square 100x100', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchorm Rotalux Square 100x100 Softbox.png'),
    fullDescription: 'Delivers soft, natural light with excellent diffusion, perfect for portraits, fashion, and product photography, ensuring consistent lighting and easy setup..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  {
    id: 128, 
    name: 'Varistar Umbrella', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Varistar Umbrella.png'),
    fullDescription: 'Provides wide, even light coverage with smooth diffusion, ideal for portrait and studio photography, offering quick setup and compatibility with various lighting systems..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 129, 
    name: 'Elinchorm Rotalux 50x130 Strip', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchorm Rotalux 50x130 Strip Softbox.png'),
    fullDescription: 'Delivers narrow, even illumination ideal for edge lighting, portraits, and product shoots, enhancing subject separation and adding depth with soft highlights..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 130, 
    name: '80cm 5 IN 1 Reflector', 
    category: 'Lights',
    originalPrice: 1500,
    price: 900,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/80cm 5 IN 1 Reflector.png'),
    fullDescription: 'Includes gold, silver, white, black, and translucent panels, allowing control over warmth, contrast, and diffusion — perfect for outdoor and studio photography..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 131, 
    name: '110cm 5 IN 1 Reflector', 
    category: 'Lights',
    originalPrice: 500,
    price: 300,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/110cm 5 IN 1 Reflector.png'),
    fullDescription: 'Includes gold, silver, white, black, and translucent panels, allowing control over warmth, contrast, and diffusion — perfect for outdoor and studio photography..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  { type: 'header', brand: 'Triger', category: 'Lights' },

  {
    id: 132, 
    name: 'Elinchorm EL Skyport', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchrom EL skyport speed transmitter.png'),
    fullDescription: 'Enables seamless wireless synchronization and power adjustment of Elinchrom lights, offering reliable performance and flexibility for studio and on-location photography..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 133, 
    name: 'Elinchorm EL Skyport Plus', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Elinchrom EL-Skyport Transmitter plus.png'),
    fullDescription: 'Enables seamless wireless synchronization and power adjustment of Elinchrom lights, offering reliable performance and flexibility for studio and on-location photography..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 134, 
    name: 'Godox X1-C', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox X1-C TTL Trigger for Canon.png'),
    fullDescription: 'Provides reliable 2.4GHz wireless control for off-camera flashes and strobes, supporting TTL, high-speed sync, and multi-flash functions for precise lighting control in any setup..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 135, 
    name: 'Godox Xpro-C', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox Xpro-C TTL Trigger for Canon.png'),
    fullDescription: 'Offers full TTL, HSS, and multi-flash control with a large LCD interface, allowing photographers to manage multiple flash groups effortlessly for professional lighting precision..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 136, 
    name: 'Godox X1-S', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox X1-S TTL Trigger for Sony.png'),
    fullDescription: 'enables reliable off-camera flash control with TTL, HSS, and multi-flash functions, providing consistent wireless performance for both studio and outdoor photography setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 137, 
    name: 'Godox Xpro-S', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox Xpro-S TTL Trigger for Sony.png'),
    fullDescription: 'Offers TTL, HSS, and multi-group flash control with a clear LCD display, enabling seamless and precise wireless lighting management for professional photo and video shoots..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 138, 
    name: 'Godox Xpro-N', 
    category: 'Lights',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights1/Godox Xpro-N TTL Trigger for Nikon.png'),
    fullDescription: 'Provides full TTL, HSS, and multi-group flash control, featuring an intuitive LCD interface for easy, precise management of multiple Godox lights in any shooting environment..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  { type: 'header', brand: 'Photo Light', category: 'Lights' },

  {
    id: 139, 
    name: 'Godox AD400 Pro', 
    category: 'Lights',
    originalPrice: 1500,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/GODOX AD400 PRO OUTDOOR FLASH.png'),
    fullDescription: 'Offers TTL, HSS, and 2.4GHz wireless control, delivering stable color temperature and fast recycling — ideal for studio and outdoor shoots requiring professional-grade lighting..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 140,
    name: 'Godox AD1200 Pro' ,
    category: 'Lights',
    originalPrice: 1800,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox AD1200 Pro LED Light.png'),
    fullDescription: 'Delivers exceptional brightness, TTL and HSS support, and consistent color accuracy, making it perfect for large-scale studio, fashion, and outdoor photography setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },  
  {
    id: 141,
    name: 'Godox AD600 Pro Strobe' ,
    category: 'Lights',
    originalPrice: 1500,
    price: 1200,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox AD600 PRO Outdoor Strobe.png'),
    fullDescription: 'Features TTL, HSS, and 2.4GHz wireless control with precise color stability, making it ideal for studio, fashion, and outdoor photography requiring consistent, high-quality lighting..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  
  {
    id: 142,
    name: 'Godox AD200 Pocket',
    category: 'Lights',
    originalPrice: 1200,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox AD200 TTL Pocket Flash.png'),
    fullDescription: 'Delivers high power in a lightweight design, featuring TTL, HSS, and 2.4GHz wireless control — ideal for on-location, portrait, and travel photography..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 143,
    name: 'Godox SK400',
    category: 'Lights',
    originalPrice: 1200,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox SK400 II Studio Flash..png'),
    fullDescription: 'Provides stable output, fast recycling, and 2.4GHz wireless control, making it ideal for portraits, product photography, and small studio setups requiring professional lighting quality..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 144,
    name: 'Elinchrom FRX 600',
    category: 'Lights',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Elinchrom FRX 600.png'),
    fullDescription: 'Delivers consistent light output with fast recycling and precise control, making it perfect for portrait, fashion, and commercial photography in professional studio environments..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 145,
    name: 'Elinchrom FRX 400',
    category: 'Lights',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Elinchrom FRX 400..png'),
    fullDescription: 'Offers consistent light output, fast recycling, and Skyport wireless control, making it ideal for portrait, product, and fashion photography in professional studios..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },
  {
    id: 146,
    name: 'Godox V860II Sony',
    category: 'Lights',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox V860II TTL Flash for Sony.png'),
    fullDescription: 'Supports 2.4GHz wireless transmission, high-speed sync up to 1/8000s, zoom range of 20–200mm, guide number 60, tilting and rotating flash head, and full TTL/Manual control for versatile lighting setups..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 147,
    name: 'Canon Speedlite 600EX ',
    category: 'Lights',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Canon Speedlite 600EX II-RT.png'),
    fullDescription: 'Features a zoom head covering 20-200 mm (14 mm with wide panel), built-in 2.4 GHz radio wireless master/slave system supporting up to 5 groups and 15 units, and rugged dust-/weather-sealed construction.',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  }, 
  {
    id: 148,
    name: 'Godox V1',
    category: 'Lights',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 18,
    rating: 4.9,
    reviews: 156,
    image: getImagePath('/assets/Lights 3/Godox V1 Flash for Sony & Canon.png'),
    fullDescription: 'Features a 2.4 GHz built-in radio system, high-speed sync up to 1/8000 s, magnetic modifier mount, zoom range 28-105 mm, and tilt/rotate head for flexible lighting..',
    features: ['Full RGBW Color Control', 'Exceptional Color Accuracy', 'Multiple Control Options', 'Built-in Effects', 'Professional Build', 'DMX/ArtNet Control'],
    specifications: { 'Power': '450W', 'Color Temp': '2800-10000K', 'CRI': '98+', 'TLCI': '98+' }
  },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
  { 
    id: 149, 
    name: 'DSC02041', 
    category: 'Studio',
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Studio/DSC02041-removebg-preview.png'),
    fullDescription: 'Our Professional Studio Setup provides everything you need for a successful shoot. Includes motorized backdrop system with multiple colors, professional lighting grid, and climate-controlled space.',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
    },
  { 
    id: 150, 
    name: 'Professional Studio Setup', 
    category: 'Studio',
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Studio/DSC02046.JPG'),
    fullDescription: 'Our Professional Studio Setup provides everything you need for a successful shoot. Includes motorized backdrop system with multiple colors, professional lighting grid, and climate-controlled space.',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 151, 
    name: 'Professional Studio Setup', 
    category: 'Studio',
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Studio/DSC02051.JPG'),
    fullDescription: 'Our Professional Studio Setup provides everything you need for a successful shoot. Includes motorized backdrop system with multiple colors, professional lighting grid, and climate-controlled space.',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 152, 
    name: 'Professional Studio Setup', 
    category: 'Studio',
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Studio/DSC02054.JPG'),
    fullDescription: 'Our Professional Studio Setup provides everything you need for a successful shoot. Includes motorized backdrop system with multiple colors, professional lighting grid, and climate-controlled space.',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 153, 
    name: 'cvw swift800 pro kit sdi hdmi wireless video transmitter', 
    category: 'Monitor',
    originalPrice: 1200,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Monitor/cvw-swift800-pro-kit-sdi-_-hdmi-wireless-video-transmission-system-removebg-preview.png'),
    fullDescription: 'The CVW Swift 800 Pro Kit offers reliable HD video transmission via SDI and HDMI with ultra-low latency and up to 800ft range. Ideal for film, broadcast, and live production setups..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 154, 
    name: '1X4 Cutter',
    category: 'Accessories',
    originalPrice: 400,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/1x4-cutter.png'),
    fullDescription: 'Helps block, shape, or diffuse light precisely, commonly used with stands, flags, and diffusion materials..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 155, 
    name: '2x2 Cutter',
    category: 'Accessories',
    originalPrice: 300,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/2x2-cutter-flag.png'),
    fullDescription: 'Ideal for cutting unwanted light, reducing spill, and adding depth to your lighting setup..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 156, 
    name: '2x3 Cutter',
    category: 'Accessories',
    originalPrice: 300,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/2x3-cutter-flag.png'),
    fullDescription: 'Designed to block, shape, and control light spill for balanced and professional lighting setups..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 157, 
    name: '3x3 Cutter',
    category: 'Accessories',
    originalPrice: 300,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/3x3-cutter-flag.png'),
    fullDescription: 'Ideal for managing light spill and creating controlled illumination on medium to large sets.',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 158, 
    name: '6X4 skimmer',
    category: 'Accessories',
    originalPrice: 1200,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/6x4-skimmer-with-diffusion-cloths.png'),
    fullDescription: 'Ideal for creating even, natural lighting and reducing harsh shadows in outdoor or studio shoots..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 159, 
    name: '4x4 Cutter',
    category: 'Accessories',
    originalPrice: 300,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/4x4-cutter-flag.png'),
    fullDescription: 'Perfect for controlling highlights, reducing spill, and achieving precise lighting on bigger scenes..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },  
  { 
    id: 160, 
    name: '6x6 Skimmer & Frame',
    category: 'Accessories',
    originalPrice: 1800,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/6x6-skimmer.png'),
    fullDescription: 'Perfect for cutting unwanted light, controlling spill, and enhancing contrast in wide or outdoor scenes..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 161, 
    name: '8x8 skimmer & Frame',
    category: 'Accessories',
    originalPrice: 1800,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/8x8-skimmer.png'),
    fullDescription: 'Ideal for blocking, shaping, and reducing light spill in outdoor shoots and wide production setups..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },   
  { 
    id: 162, 
    name: '10x10 Skimmer & Frame',
    category: 'Accessories',
    originalPrice: 2300,
    price: 2000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/10x10--skimmer.png'),
    fullDescription: 'Perfect for blocking sunlight, controlling spill, and creating balanced lighting in big outdoor productions..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 163, 
    name: '12x12 Skimmer & Frame',
    category: 'Accessories',
    originalPrice: 2500,
    price: 2200,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/12x12-skimmer.png'),
    fullDescription: ' Ideal for blocking strong sunlight, reducing spill, and achieving precise lighting in large outdoor or studio productions..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 164, 
    name: '15x15 Skimmer & frame',
    category: 'Accessories',
    originalPrice: 2800,
    price: 2500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Accessories/15x15-skimmer.png'),
    fullDescription: 'Designed to block and shape broad light sources, providing full control over spill and contrast on large sets. .',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 165, 
    name: 'Arm Rod 2ft and 3ft',
    category: 'Accessories',
    originalPrice: 400,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.8,
    reviews: 45,
    image: getImagePath('/assets/Accessories/Arm-rod--2ft-and-3ft..png'),
    fullDescription: 'Professional arm rod set featuring 2ft and 3ft extensions, ideal for mounting lights, microphones, or other equipment with adjustable reach and positioning flexibility.',
    features: ['2ft and 3ft Extension Arms', 'Flexible Positioning', 'Durable Construction', 'Easy Mounting', 'Versatile Applications'],
    specifications: { 'Lengths': '2ft, 3ft', 'Material': 'Steel/Aluminum', 'Weight Capacity': '10-15 kg', 'Mount Type': 'Standard' }
  },
  { 
    id: 166, 
    name: 'Big C Stands 13ft',
    category: 'Accessories',
    originalPrice: 400,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.9,
    reviews: 78,
    image: getImagePath('/assets/Accessories/Big-c-stands-13ft.png'),
    fullDescription: 'Robust 13ft C-stand system designed for professional film and photography setups. Features sturdy legs, adjustable height, and versatile grip head for mounting lights, flags, and other equipment.',
    features: ['13ft Maximum Height', 'Heavy-Duty Construction', '3-Leg Stability', 'Adjustable Grip Head', 'Professional Grade'],
    specifications: { 'Max Height': '13ft', 'Weight Capacity': '20-30 kg', 'Leg Span': 'Variable', 'Material': 'Steel' }
  },
  { 
    id: 167, 
    name: 'Black Cloth 10x10',
    category: 'Accessories',
    originalPrice: 800,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.7,
    reviews: 52,
    image: getImagePath('/assets/Accessories/Black-cloth-10x10.png'),
    fullDescription: 'High-quality 10x10 foot black backdrop cloth designed for studio and location shoots. Provides seamless background coverage with excellent light absorption for clean, professional results.',
    features: ['10x10 Foot Size', 'Black Color', 'Durable Material', 'Easy Setup', 'Professional Quality'],
    specifications: { 'Size': '10x10 ft', 'Material': 'Fabric', 'Color': 'Black', 'Use': 'Backdrop' }
  },
  { 
    id: 168, 
    name: 'Black Cloth 12x12',
    category: 'Accessories',
    originalPrice: 900,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.7,
    reviews: 48,
    image: getImagePath('/assets/Accessories/Black-cloth-12x12.png'),
    fullDescription: 'Premium 12x12 foot black backdrop cloth ideal for larger shooting spaces. Features excellent light absorption and wrinkle-resistant material for consistent, professional background results.',
    features: ['12x12 Foot Size', 'Black Color', 'Durable Construction', 'Easy Maintenance', 'Professional Grade'],
    specifications: { 'Size': '12x12 ft', 'Material': 'Fabric', 'Color': 'Black', 'Use': 'Backdrop' }
  },
  { 
    id: 169, 
    name: 'Black Cloth 20x20',
    category: 'Accessories',
    originalPrice: 900,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.8,
    reviews: 35,
    image: getImagePath('/assets/Accessories/Black-cloth-20x20.png'),
    fullDescription: 'Extra-large 20x20 foot black backdrop cloth designed for big studio spaces and commercial photography. Provides seamless coverage with professional-grade material for high-end productions.',
    features: ['20x20 Foot Size', 'Black Color', 'Premium Material', 'Large Coverage', 'Commercial Grade'],
    specifications: { 'Size': '20x20 ft', 'Material': 'Fabric', 'Color': 'Black', 'Use': 'Backdrop' }
  },
  { 
    id: 170, 
    name: 'Blue Cloth 10x10',
    category: 'Accessories',
    originalPrice: 900,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 19,
    rating: 4.7,
    reviews: 43,
    image: getImagePath('/assets/Accessories/blu -cloth-10x10.png'),
    fullDescription: 'Vibrant 10x10 foot blue backdrop cloth perfect for adding color and style to your photography. Ideal for portraits, product shoots, and creative video productions with professional quality material.',
    features: ['10x10 Foot Size', 'Blue Color', 'Durable Material', 'Colorfast', 'Easy Setup'],
    specifications: { 'Size': '10x10 ft', 'Material': 'Fabric', 'Color': 'Blue', 'Use': 'Backdrop' }
  },
  { 
    id: 171, 
    name: 'Medium Boomrod with Stand',
    category: 'Accessories',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.8,
    reviews: 67,
    image: getImagePath('/assets/Accessories/Medium Boomrod with stand.png'),
    fullDescription: 'Complete medium boom rod kit with included stand for flexible microphone positioning. Ideal for film, video, and broadcast applications where overhead audio capture is needed.',
    features: ['Medium Length Boom Rod', 'Included Stand', 'Adjustable Height', 'Secure Mounting', 'Professional Audio Support'],
    specifications: { 'Boom Length': 'Medium', 'Stand Included': 'Yes', 'Weight Capacity': '2-3 kg', 'Material': 'Aluminum/Steel' }
  },
  { 
    id: 172, 
    name: 'Cutter Stands',
    category: 'Accessories',
    originalPrice: 500,
    price: 200,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.6,
    reviews: 38,
    image: getImagePath('/assets/Accessories/cutter-stands.png'),
    fullDescription: 'Sturdy stands specifically designed for mounting cutter flags and light control equipment. Features adjustable height and stable base for secure positioning of flags and diffusion materials.',
    features: ['Adjustable Height', 'Stable Base', 'Flag Mounting', 'Portable Design', 'Professional Build'],
    specifications: { 'Max Height': 'Variable', 'Weight Capacity': '5-10 kg', 'Material': 'Steel', 'Mount Type': 'Flag/Cutter' }
  },
  { 
    id: 173, 
    name: 'Green Cloth 12x12',
    category: 'Accessories',
    originalPrice: 900,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.7,
    reviews: 41,
    image: getImagePath('/assets/Accessories/Green-cloth-12x12.png'),
    fullDescription: 'High-quality 12x12 foot green backdrop cloth perfect for chroma key compositing and green screen work. Also suitable for colorful creative backgrounds in studio and location photography.',
    features: ['12x12 Foot Size', 'Green Color', 'Chroma Key Compatible', 'Durable Material', 'Professional Quality'],
    specifications: { 'Size': '12x12 ft', 'Material': 'Fabric', 'Color': 'Green', 'Use': 'Backdrop/Chroma Key' }
  },
  { 
    id: 174, 
    name: 'Green Cloth 15x15',
    category: 'Accessories',
    originalPrice: 15000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.8,
    reviews: 33,
    image: getImagePath('/assets/Accessories/Green-cloth-15x15..png'),
    fullDescription: 'Premium 15x15 foot green backdrop cloth designed for large-scale green screen work and chroma key compositing. Ideal for commercial productions, music videos, and film projects requiring extensive background coverage.',
    features: ['15x15 Foot Size', 'Green Color', 'Professional Chroma Key', 'Wrinkle Resistant', 'Commercial Grade'],
    specifications: { 'Size': '15x15 ft', 'Material': 'Fabric', 'Color': 'Green', 'Use': 'Backdrop/Chroma Key' }
  },
   
  { 
    id: 175, 
    name: 'Light Weight Triple Height Stand',
    category: 'Accessories',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 20,
    rating: 4.7,
    reviews: 44,
    image: getImagePath('/assets/Accessories/Light-weight-triple-height-stand.png'),
    fullDescription: 'Portable lightweight stand with triple-height adjustment system. Ideal for location shoots requiring easy transport and quick setup of lights, cameras, or other equipment.',
    features: ['Lightweight Design', 'Triple Height Adjustment', 'Portable', 'Quick Setup', 'Versatile Use'],
    specifications: { 'Max Height': 'Variable', 'Weight': 'Light', 'Material': 'Aluminum', 'Weight Capacity': '5-8 kg' }
  },
{ 
    id: 176, 
    name: 'Lilliput a7s7 Field Monitor', 
    category: 'Monitor',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Monitor/lilliput-a7s-7-field-monitor-removebg-preview.png'),
    fullDescription: 'The Lilliput A7S 7-inch field monitor offers 1920x1200 resolution, HDMI input/output, and professional monitoring tools, making it ideal for filmmakers and videographers..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 177, 
    name: 'Lilliput bm230 4k 23.8 Moniter', 
    category: 'Monitor',
    originalPrice: 2000,
    price: 1500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Monitor/lilliput-bm230-4k-23.8--monitor-removebg-preview.png'),
    fullDescription: 'The Lilliput BM230-4K 23.8-inch monitor delivers UHD 4K resolution, wide viewing angles, and multiple input options, ideal for studio, post-production, and broadcast use..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 178, 
    name: 'Yolo Box Pro', 
    category: 'Monitor',
    originalPrice: 6000,
    price: 5000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Monitor/yolo-box-pro-removebg-preview.png'),
    fullDescription: 'The YoloBox Pro combines encoder, monitor, switcher, and recorder functions in one portable device, supporting multi-platform live streaming with HDMI, USB, and SD card inputs..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 179, 
    name: '88MM Variable ND Filter', 
    category: 'Filter',
    originalPrice: 800,
    price: 300,
    ShortDescription: 'For More details, Contact Us',
    discount: 24,
    rating: 4.8,
    reviews: 168,
    image: getImagePath('/assets/ND Filters 1/82MM VARIABLE ND FILTERS.png'),
    fullDescription: 'The 88MM Variable ND Filter is a premium professional-grade neutral density filter designed for high-end cinematography and photography applications. This large-diameter filter provides smooth, continuous light reduction from ND2 to ND400 (approximately 1.3 to 8.6 stops), giving filmmakers and photographers complete control over exposure in bright lighting conditions. Engineered with precision-ground optical glass and multi-layer nano-coating, it maintains true color reproduction and prevents the common X-pattern effect seen in lower-quality variable ND filters. The 88mm size is ideal for professional cinema lenses, wide-angle lenses, and zoom lenses that require larger filter diameters. This filter allows you to maintain shallow depth of field at wide apertures even in bright sunlight, achieve cinematic motion blur with slower shutter speeds, and control exposure without compromising image quality. Perfect for outdoor shoots, travel videography, and professional studio work where precise exposure control is essential.',
    features: ['Variable ND2-ND400 Range', 'Multi-Coated Glass', 'Thread Mount Design', 'Color Neutral Transmission', 'Prevents X-Pattern Effect', 'Professional Quality'],
    specifications: { 'Filter Size': '88mm', 'ND Range': 'ND2-ND400', 'Construction': 'Optical Glass', 'Thread Type': 'Standard 88mm', 'Coating': 'Multi-Coated' }
  },
  { 
    id: 180, 
    name: '77MM Variable ND Filter', 
    category: 'Filter',
    originalPrice: 800,
    price: 300,
    ShortDescription: 'For More details, Contact Us',
    discount: 27,
    rating: 4.8,
    reviews: 142,
    image: getImagePath('/assets/ND Filters 1/77MM VARIABLE ND FILTERS.png'),
    fullDescription: 'The 77MM Variable ND Filter is an essential tool for photographers and videographers seeking precise exposure control in any lighting condition. With a variable density range from ND2 to ND400 (1.3 to 8.6 stops), this filter provides seamless light reduction that allows you to maintain optimal aperture and shutter speed settings regardless of ambient light levels. Featuring premium optical glass construction with multi-layer nano-coating, it ensures minimal color cast, preserves image sharpness, and eliminates the unwanted X-pattern effect common in budget variable ND filters. Perfect for portrait photography where you want to shoot wide open in bright conditions, landscape photography requiring longer exposures for dramatic effects, and video production where maintaining cinematic shutter speeds is crucial. The 77mm size fits most professional and enthusiast-level lenses, making it an excellent choice for wedding photographers, travel videographers, and content creators who need reliable, high-quality exposure control without carrying multiple fixed-density filters.',
    features: ['Variable ND2-ND400 Range', 'Multi-Coated Glass', 'Thread Mount Design', 'Color Neutral Transmission', 'Prevents X-Pattern Effect', 'Professional Quality'],
    specifications: { 'Filter Size': '77mm', 'ND Range': 'ND2-ND400', 'Construction': 'Optical Glass', 'Thread Type': 'Standard 77mm', 'Coating': 'Multi-Coated' }
  },
  { 
    id: 181, 
    name: 'Canon mount adapter ef eos', 
    category: 'Filter',
    originalPrice: 800,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/canon-mount-adapter-ef-eos-r-removebg-.png'),
    fullDescription: 'The Canon Mount Adapter EF-EOS seamlessly connects EF and EF-S lenses to EOS R series mirrorless cameras, maintaining full autofocus and image stabilization performance..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 182, 
    name: 'Filter stepper Rings For all lens', 
    category: 'Filter',
    originalPrice: 500,
    price: 100,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/filter-stepper-rings-for-all-lens-removebg-preview.png'),
    fullDescription: 'Filter stepper rings adapt lenses and filters of varying diameters, allowing photographers to use one filter set across multiple lenses efficiently..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 183, 
    name: 'H Y Filter RevoRig VariableNeutralDensityND3', 
    category: 'Filter',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/H_Y-Filter-RevoRing-VariableNeutralDensityND3-1000Filter67-82mm-1-removebg-preview.png'),
    fullDescription: 'The H&Y RevoRing Variable Neutral Density ND3 filter provides smooth, adjustable exposure control, combining flexibility and precision for photographers and videographers..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 184, 
    name: 'MetaBase ef e Mount Adapter', 
    category: 'Filter',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/metabones-ef-e-mount-adapter--removebg-preview.png'),
    fullDescription: 'The Metabones EF-E Mount Adapter enables seamless use of Canon EF lenses on Sony E-mount mirrorless cameras, supporting autofocus, aperture control, and image stabilization..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 185, 
    name: 'Redrock Mattbox with 4x5.65 nd pl', 
    category: 'Filter',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/redrock-mattbox-with-4x5.65-nd-_-pl-filters-removebg-preview.png'),
    fullDescription: 'The Redrock Matte Box with 4x5.65 ND and Polarizing filters offers professional light control, reducing reflections and enhancing contrast for film and video production..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 186, 
    name: 'Tiffen 82mm Variable nd Filter', 
    category: 'Filter',
    originalPrice: 500,
    price: 300,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/tiffen-82mm-variable-nd-filter-removebg-preview.png'),
    fullDescription: 'Tiffens 82mm Variable ND Filter lets photographers and filmmakers fine-tune light reduction, enabling smooth exposure control without changing aperture or shutter speed..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },  
  { 
    id: 187, 
    name: 'Tilta mb t06 6.6x6.6 inch carbon fiber matte box', 
    category: 'Filter',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Filter/tilta-mb-t06-6.6x6.6-inch-carbon-fiber-matte-box-removebg-preview.png'),
    fullDescription: 'The Tilta MB-T06 carbon fiber matte box accommodates 6.6x6.6-inch filters, offering lightweight, durable light control for high-end film and video production..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 188, 
    name: '6ft heavy cine slider', 
    category: 'Tripod',
    originalPrice: 1200,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/6ft-heavy-cine-slider-removebg-preview.png'),
    fullDescription: 'A 6ft Heavy Cine Slider ensures precise, fluid tracking shots with strong build quality, ideal for cinematic video production and heavy camera rigs..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },
  { 
    id: 189, 
    name: 'Cine Slider 4 Feet', 
    category: 'Tripod',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/Cine-slider-removebg-preview (1).png'),
    fullDescription: 'The Cine Slider is a professional camera tool designed to create fluid horizontal or angled motion, enhancing production value in films and videos..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 190, 
    name: '7020 7ft tripod', 
    category: 'Tripod',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/e-image-7020-7ft-tripod-removebg-preview.png'),
    fullDescription: 'The 7020 7ft Tripod features durable construction and adjustable height, ensuring steady shots for photography and videography..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 
  { 
    id: 191, 
    name: '7050 50mm tripod', 
    category: 'Tripod',
    originalPrice: 1000,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/e-image-7050-50mm-tripod-removebg-preview.png'),
    fullDescription:'The 7050 50mm Tripod provides reliable stability with a lightweight design, ideal for portable photography and videography setups..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },  
  { 
    id: 192, 
    name: 'Super Tech Tripod', 
    category: 'Tripod',
    originalPrice: 1200,
    price: 1000,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/fluid-head-tripod-removebg-preview.png'),
    fullDescription:'The Fluid Head Tripod features a fluid damping system, providing precise, stable camera movements for cinematic shots and live video production..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  },  
  { 
    id: 193, 
    name: 'Manfrotto Monopod', 
    category: 'Tripod',
    originalPrice: 900,
    price: 400,
    ShortDescription: 'For More details, Contact Us',
    discount: 21,
    rating: 4.9,
    reviews: 89,
    image: getImagePath('/assets/Tripod/manfrotto-monopod-removebg-preview.png'),
    fullDescription:'Manfrotto Monopod provides stability and flexibility for handheld shooting, ideal for sports, wildlife, and on-the-go videography..',
    features: ['Motorized Backdrop System', '500 sq ft Space', 'Professional Lighting Grid', 'Climate Controlled', 'Makeup Area', 'Equipment Storage'],
    specifications: { 'Size': '500 sq ft', 'Ceiling Height': '14 ft', 'Power': '220V Available', 'Duration': 'Per Day' }
  }, 

  { 
    id: 194, 
    name: 'Hollyland Video Transmitter', 
    category: 'Monitor',
    originalPrice: 1000,
    price: 600,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/Hollyland_Wireless_Transmission-removebg-preview.png'),
    fullDescription: 'Offers reliable wireless connectivity, low-latency transmission, and excellent sound quality. Perfect for filmmaking, vlogging, interviews, and professional content creation. Features long-range operation, noise reduction, and easy setup for seamless integration with cameras and recording devices.',
    features: ['Wireless Transmission', 'Low-Latency Audio', 'Long-Range Operation', 'Noise Reduction', 'Compact Receiver Design', 'Easy Setup'],
    specifications: { 'Type': 'Wireless Microphone System', 'Range': 'Up to 200m', 'Latency': 'Minimal', 'Battery': 'Rechargeable', 'Weight': 'Lightweight' }
  },
  { 
    id: 195, 
    name: 'E-IMAGE TRIPAD', 
    category: 'Tripod',
    originalPrice: 900,
    price: 500,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/E-IMAGE TRIPAD.png'),
    fullDescription: 'Offers stable support, adjustable height, and durable construction for professional audio recording setups. Perfect for studio recording, field production, and live sound applications. Features sturdy build quality, flexible positioning, and compatibility with various microphone and audio equipment configurations.',
    features: ['Stable Three-Leg Design', 'Adjustable Height', 'Durable Construction', 'Heavy-Duty Base', 'Quick Setup', 'Portable Design'],
    specifications: { 'Type': 'Audio Tripod Stand', 'Max Height': 'Adjustable', 'Material': 'Aluminum Alloy', 'Weight': 'Lightweight', 'Load Capacity': 'Professional Grade' }
  },
  { 
    id: 196, 
    name: 'Baofeng BF-8885 Walkie Talkie 1Set', 
    category: 'Audio',
    originalPrice: 400,
    price: 150,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/baofeng-bf-8885-walkie-talkie-removebg.png'),
    fullDescription: 'Provides reliable UHF performance, long battery life, and easy operation. Ideal for security teams, events, outdoor communication needs, and professional coordination. Features 16-channel operation, emergency alert function, battery saving mode, and robust construction for dependable communication in various environments.',
    features: ['16-Channel Operation', 'UHF Frequency Range', 'Long Battery Life', 'Emergency Alert', 'Scan Function', 'Robust Construction'],
    specifications: { 'Type': 'Two-Way Radio', 'Frequency': 'UHF 400-470MHz', 'Channels': '16', 'Range': 'Up to 5km', 'Battery': '1800mAh' }
  },
  { 
    id: 197, 
    name: 'Teleprompter', 
    category: 'Monitor',
    originalPrice: 7000,
    price: 6000,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/TELEPROMPTER.png'),
    fullDescription: 'Offers reflective screen technology, adjustable brightness, and easy setup for professional video recording. Perfect for news broadcasting, video production, presentations, and live streaming. Features clear text display, eye-level positioning, camera compatibility, and portable design for seamless integration into any production setup.',
    features: ['Reflective Screen', 'Adjustable Brightness', 'Camera Compatible', 'Eye-Level Positioning', 'Portable Design', 'Easy Setup'],
    specifications: { 'Type': 'Teleprompter System', 'Screen Size': 'Variable', 'Compatibility': 'Universal Camera', 'Mount': 'Tripod Compatible', 'Weight': 'Lightweight' }
  },
  { 
    id: 198, 
    name: 'Zoom H6 Handy Audio Recorder', 
    category: 'Audio',
    originalPrice: 1200,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 17,
    rating: 4.9,
    reviews: 289,
    image: getImagePath('/assets/audio 2/zoom-h6-handy-audio-recorder-removebg-preview (1).png'),
    fullDescription: 'Features six-track simultaneous recording, interchangeable microphone capsules, and high-quality preamps. Perfect for field recording, interviews, music production, and podcast creation. Offers flexible input options, USB audio interface capability, battery-powered operation, and intuitive controls for professional audio professionals on the go.',
    features: ['6-Track Recording', 'Interchangeable Capsules', 'High-Quality Preamps', 'USB Audio Interface', 'Portable Design', 'Battery Powered'],
    specifications: { 'Type': 'Portable Audio Recorder', 'Tracks': '6 Simultaneous', 'Inputs': '2 XLR/TRS', 'Battery': 'AA Batteries', 'Weight': '280g' }
  },
  { 
    id: 199, 
    name: 'Red Gemini 6K', 
    category: 'Camera Combo',
    originalPrice: 8000,
    price: 7000,
    ShortDescription: 'Camera with Any 4 GM lens',
    discount: 25,
    rating: 4.9,
    reviews: 198,
    image: getImagePath('/assets/Camera/Red Gemini 6K.png'),
    fullDescription: 'Delivers stunning 6K resolution, wide dynamic range, and cinematic color reproduction. This combo includes camera body, professional lens, battery pack, memory cards, and essential accessories. Ideal for filmmakers seeking a complete production solution in both bright and low-light conditions with remarkable detail and flexibility.',
    features: ['6K Cinema Camera', 'Dual ISO Sensor', 'Complete Accessory Kit', 'Professional Grade', 'Wide Dynamic Range', 'Cinematic Color'],
    specifications: { 'Type': 'Cinema Camera Combo', 'Resolution': '6K', 'Sensor': 'Full-Frame', 'Package': 'Complete Kit', 'Accessories': 'Included' }
  },
    { 
    id: 200, 
    name: 'Sony FX3', 
    category: 'Camera Combo',
    originalPrice: 8000,
    price: 7000,
    ShortDescription: 'Camera with Any 4 GM lens',
    discount: 28,
    rating: 4.9,
    reviews: 203,
    image: getImagePath('/assets/Camera/FX3.png'),
    fullDescription: 'Delivers cinematic 4K video, excellent low-light performance, and advanced autofocus. This combo package includes camera body, versatile lens, gimbal stabilizer, audio equipment, batteries, and professional carrying case. Combining the power of Sony\'s Cinema Line with portable design, perfect for handheld and on-the-go shooting with complete production tools.',
    features: ['Compact Cinema Camera', '4K Video', 'Gimbal Stabilizer', 'Audio Equipment', 'Portable Design', 'Complete Kit'],
    specifications: { 'Type': 'Cinema Camera Combo', 'Resolution': '4K', 'Sensor': 'Full-Frame', 'Package': 'Filmmaker Kit', 'Weight': 'Lightweight' }
  },
  { 
    id: 201, 
    name: 'Sony A7 S III ', 
    category: 'Camera Combo',
    originalPrice: 7000,
    price: 6000,
    ShortDescription: 'Camera with Any 4 GM lens',
    discount: 29,
    rating: 4.9,
    reviews: 187,
    image: getImagePath('/assets/Camera/sony 2.png'),
    fullDescription: 'Offers 4K 120p recording, superb dynamic range, and fast autofocus. This pro combo includes camera body, professional lens, external recorder, audio accessories, extra batteries, and comprehensive accessory kit. Ideal for filmmakers and content creators, it excels in cinematic production and high-sensitivity shooting with complete production capabilities.',
    features: ['Full-Frame Mirrorless', '4K 120p Recording', 'External Recorder', 'Audio Accessories', 'Professional Lens', 'Complete Kit'],
    specifications: { 'Type': 'Mirrorless Camera Combo', 'Resolution': '4K 120p', 'Sensor': 'Full-Frame', 'Package': 'Pro Combo', 'Accessories': 'Comprehensive' }
  },
  { 
    id: 202, 
    name: 'Sony A7 R IV ', 
    category: 'Camera Combo',
    originalPrice: 5500,
    price: 4500,
    ShortDescription: 'Camera with Any 4 GM lens',
    discount: 26,
    rating: 4.9,
    reviews: 224,
    image: getImagePath('/assets/Camera/SONY A7 R IV .png'),
    fullDescription: 'Features a 61MP sensor, fast autofocus, and excellent color accuracy. This photography combo includes camera body, premium lens, professional flash, tripod, memory cards, and camera bag. Perfect for landscape, studio, and commercial photography, it offers professional-grade sharpness and performance with complete photography essentials.',
    features: ['61MP High-Resolution', 'Fast Autofocus', 'Premium Lens', 'Professional Flash', 'Tripod Included', 'Complete Package'],
    specifications: { 'Type': 'Mirrorless Camera Combo', 'Resolution': '61MP', 'Sensor': 'Full-Frame', 'Package': 'Photography Kit', 'Accessories': 'Professional' }
  },
  { 
    id: 204,  
    name: 'Body Rig', 
    category: 'Gimbal',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'Professional shoulder mount gimbal system for comfortable extended shooting with superior weight distribution and advanced stabilization',
    discount: 30,
    rating: 4.8,
    reviews: 156,
    image: getImagePath('/assets/Gimbal/BodyRig.png'),
    fullDescription: 'Professional body rig shoulder mount system engineered for extended shooting comfort and exceptional stability. Features an ergonomic design that distributes camera weight evenly across the shoulder and body, reducing fatigue during long filming sessions. The advanced stabilization system ensures smooth, cinematic footage even during dynamic movements and handheld operation. Built with premium materials and adjustable components, this rig accommodates DSLR and mirrorless cameras up to 5kg payload. Perfect for documentary filmmakers, event videographers, and content creators who require professional-grade stabilization without compromising on comfort during extended shoots. The versatile mounting system allows for easy camera attachment and quick adjustments, making it ideal for run-and-gun style production where mobility and comfort are paramount.',
    features: ['Ergonomic Shoulder Mount', 'Advanced Stabilization', 'Comfortable Weight Distribution', 'Extended Shooting Support', 'Professional Build Quality', 'Versatile Camera Compatibility'],
    specifications: { 'Type': 'Shoulder Mount Gimbal', 'Payload': 'Up to 5kg', 'Mount': 'Shoulder', 'Weight Distribution': 'Ergonomic', 'Compatibility': 'DSLR & Mirrorless Cameras' }
  },
  { 
    id: 203, 
    name: 'shoulder mount gimbal', 
    category: 'Gimbal',
    originalPrice: 1000,
    price: 700,
    ShortDescription: 'For More details, Contact Us',
    discount: 30,
    rating: 4.8,
    reviews: 156,
    image: getImagePath('/assets/Gimbal/shoulder_mount.png'),
    fullDescription: 'Professional shoulder mount gimbal system designed for comfortable, extended shooting sessions. Offers superior weight distribution, advanced stabilization, and ergonomic design for handheld video production. Ideal for documentary filming, event coverage, and long-duration shoots where comfort and stability are essential.',
    features: ['Ergonomic Shoulder Mount', 'Advanced Stabilization', 'Comfortable Weight Distribution', 'Extended Shooting Support', 'Professional Build Quality', 'Versatile Camera Compatibility'],
    specifications: { 'Type': 'Shoulder Mount Gimbal', 'Payload': 'Up to 5kg', 'Mount': 'Shoulder', 'Weight Distribution': 'Ergonomic', 'Compatibility': 'DSLR & Mirrorless Cameras' }
  },
];

